"use client";

import { useEffect } from "react";

import { sendWebEvent } from "~/lib/webevents/WebEventsClient";
import { useUnauthorizedEventService } from "~/services/api/services/event";
import { Button } from "~/componentsND/buttons/ButtonND";
import { QUIZ_ROUTES } from "~/constants/quizRoutes";
import { useQuizLink } from "~/components/features/quiz";

export default function NotFoundContent() {
    const sendBigQueryEvent = useUnauthorizedEventService();
    const { href: quizHref } = useQuizLink(QUIZ_ROUTES.HORMONE_IMBALANCE);

    useEffect(() => {
        void sendWebEvent(sendBigQueryEvent, {
            event_name: "error",
            event_type: "user_non_interaction",
            widget: "page_error",
            meta_data: {
                url: window.location.href,
                error_text: "This page could not be found.",
                error_msg_response: "404"
            },
        });
    }, [sendBigQueryEvent]);

    return (
        <section data-not-found className="font-[Helvetica] py-24 px-4 sm:px-6 bg-[url(https://res.cloudinary.com/dirscuuhp/image/upload/v1760367531/new_design/404_lbtwnn.webp)] bg-[auto_140%] lg:bg-[1920px_auto] 2xl:bg-cover bg-[calc(50%-140px)_60%] md:bg-[calc(50%-90px)_60%] lg:bg-[50%_82%] 2xl:bg-[50%_calc(50%-19vw)] -mb-6 lg:-mb-12">
            <div className="max-w-[1328px] mx-auto">
                <div className="flex flex-col lg:justify-center lg:max-w-[520px] max-lg:text-center min-h-[620px] md:min-h-[760px]">
                    <h2 className="font-items text-[48px] lg:text-[78px] leading-none text-heroBlue mb-2 max-lg:max-w-[300px] max-lg:mx-auto">
                        Looks like this page is out of balance!
                    </h2>

                    <p className="text-heroBlue text-base lg:text-lg">
                        But don’t worry—we’ll help you get back on track.
                    </p>

                    <div className="flex max-lg:flex-col max-lg:max-w-[230px] max-lg:mx-auto gap-3 mt-5">
                        <Button
                            href={quizHref}
                            text="Take the health quiz"
                            gtmEventData={{
                                event: "user_interaction",
                                value: {
                                    event_name: "404_interaction",
                                    widget: "404",
                                    meta_data: {},
                                },
                            }}
                        />

                        <Button
                            href="/"
                            text="Back to homepage"
                            variant="secondary"
                            className="bg-transparent border-2 border-heroBlue"
                            gtmEventData={{
                                event: "user_interaction",
                                value: {
                                    event_name: "404_interaction",
                                    widget: "404",
                                    meta_data: {},
                                },
                            }}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}
